import TenantLayout from "pages/Layout/Tenant/TenantLayout";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isQldRegion } from "utils/petFormHelpers";
import Icon from "../../components/UI/Icon/Icon";
import { secureLocalStorage } from "../../utils/secureStorage";

const ApplicationCompleted: React.FC = () => {
  const [agentName, setAgentName] = useState<string | null>(null);
  const [agentCompany, setAgentCompany] = useState<string | null>(null);
  const [allTenantsName, setAllTenantsName] = useState<string | null>(null);
  const location = useLocation();
  const isSaveAndExit = (location.state as { saveAndExit?: boolean } | null)?.saveAndExit === true;

  useEffect(() => {
    const loadData = async () => {
      const name = await secureLocalStorage.getItem("agent_name");
      const company = await secureLocalStorage.getItem("agent_company");
      const tenants = await secureLocalStorage.getItem("tenantNames");
      setAgentName(name);
      setAgentCompany(company);
      setAllTenantsName(tenants);
    };
    loadData();
  }, []);

  // Prevent browser back button - application already submitted
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // Push state back to prevent navigation
      window.history.pushState(null, "", window.location.pathname);
    };

    // Add initial history entry to prevent back navigation
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <TenantLayout roleType="tenant" activeStage={3}>
      <div className="min-h-400px d-flex flex-column gap-40px align-items-center justify-content-center text-center">
        <div className="d-flex gap-30px align-items-center">
          <Icon name="dog" size={40} />
          <Icon name="cat" size={40} />
          <Icon name="bird" size={40} />
        </div>
        <div className="d-flex flex-column gap-40px">
          {isSaveAndExit ? (
            <div className="d-flex flex-column gap-10px">
              <div className="fs-18px fw-bold text-black">
                Your application has been saved
              </div>
              <div className="fs-16px text-grey">
                Your progress has been saved successfully. You can return to complete and submit your application at any time using the link sent to your email.
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex flex-column gap-10px">
                <div className="fs-18px fw-bold text-black">
                  One step left to finalise your application
                </div>
                <div className="fs-16px text-grey">
                    Please check your inbox and/or SMS messages for instructions on signing. <br />
                    Signatures are required by: {allTenantsName || ""}
                </div>
              </div>

              <div className="fs-16px text-grey">
                <span className="fw-bold">What happens after {isQldRegion() ? "you" : "all tenants"} sign:</span> <br />
                We will send your application to {agentName} at {agentCompany}.
                <br />
                <br />
                Once the landlord or agent receives your application, they must review it and provide a response within {isQldRegion() ? 14 : 21} days.
              </div>
            </>
          )}
        </div>
      </div>
    </TenantLayout>
  );
};

export default ApplicationCompleted;
